const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M26.6701%200L13.3301%2013.33H26.6701V40L40.0001%2026.7V0H26.6701Z'%20fill='%23EA5616'/%3e%3cpath%20d='M13.33%2040L26.67%2026.67H13.33V0L0%2013.3V40H13.33Z'%20fill='%232C2D84'/%3e%3c/svg%3e";
export {
  e as default
};
